import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ThemeProvider from './theme';
import ScrollToTop from './components/scroll-to-top';
import { ModalProvider } from './context/modalContext';
import store from './redux/store';
import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // development
  // <GoogleOAuthProvider clientId="1062906855545-escifp12nfv2pfmdki73lc1hipuu1rei.apps.googleusercontent.com">
  // production
  <GoogleOAuthProvider clientId="385848479218-4omavnq9e8nie65vkerb1jgd4bt2on0d.apps.googleusercontent.com">
    <Provider store={store}>
      <BrowserRouter>
        <ModalProvider>
          <HelmetProvider>
            <ThemeProvider>
              <ScrollToTop />
              <App />
            </ThemeProvider>
          </HelmetProvider>
        </ModalProvider>
      </BrowserRouter>
    </Provider>
  </GoogleOAuthProvider>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
